import { connect } from 'react-refetch';
import { compose, setDisplayName, withHandlers, withProps, withStateHandlers } from 'recompose';
import { withMMGRSettings } from '../withMMGRSettings';

export type TSelectRecommendedCategories = (categories: string[]) => Partial<IState>;

interface IState {
  recommendedCategories: string[];
  recommendedCategoriesError: string;
}

type TStateUpdaters = {
  selectRecommendedCategories: TSelectRecommendedCategories;
  setRecommendedCategoriesError: (string) => Partial<IState>;
};

export const withMediaHome = compose<{}, any>(
  setDisplayName('withMediaHome'),
  withMMGRSettings,
  withStateHandlers<IState, TStateUpdaters>(
    { recommendedCategories: [], recommendedCategoriesError: null },
    {
      selectRecommendedCategories: () => (categories) => ({
        recommendedCategories: categories,
      }),
      setRecommendedCategoriesError: () => (recommendedCategoriesError) => ({
        recommendedCategoriesError,
      }),
    },
  ),
  connect<any>(({ getRecommendedCategoriesMP, selectRecommendedCategories, setRecommendedCategoriesError }) => ({
    savedRecommendedTopicsRequest: {
      comparison: '',
      value: () => getRecommendedCategoriesMP(),
      then: (response: any) => selectRecommendedCategories(response.data),
      catch: (error) => setRecommendedCategoriesError(error),
    },
  })),

  withProps(({ savedRecommendedTopicsRequest }) => ({
    isRecommendedCategoriesLoading: !savedRecommendedTopicsRequest.fulfilled && !savedRecommendedTopicsRequest.rejected,
  })),

  withHandlers(() => ({
    selectRecommendedCategories:
      ({ updateRecommendedCategoriesMP, selectRecommendedCategories }) =>
      (categories) => {
        updateRecommendedCategoriesMP(categories).then(() => selectRecommendedCategories(categories));
      },
  })),
);
